function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useEffect, useState } from 'react';
import StatsCalculations from 'libs/StatsCalculations';
import { calculateData } from 'helpers/kpi';
import { useStandards } from 'hooks';
export const useChartData = (readings30, customRanges, batchesIndex)=>{
    const standards = useStandards();
    const [chartData, setChartData] = useState(null);
    const [chartDataPreMeal, setChartDataPreMeal] = useState(null);
    const [chartDataPostMeal, setChartDataPostMeal] = useState(null);
    const getChartData = (readings)=>{
        const statsCalculations = new StatsCalculations(readings, standards, customRanges, 'value', 'timestamp');
        const averageData = statsCalculations.group('HOURS_RANGE', 'MEAN').map((item)=>_object_spread_props(_object_spread({}, item), {
                isAverage: true
            }));
        return {
            readings: statsCalculations.group('HOURS_RANGE', 'NONE'),
            averageData
        };
    };
    useEffect(()=>{
        const { preMealReadings, postMealReadings } = calculateData(readings30);
        const data = getChartData(readings30);
        const dataPreMeal = getChartData(preMealReadings);
        const dataPostMeal = getChartData(postMealReadings);
        setChartData(data);
        setChartDataPreMeal(dataPreMeal);
        setChartDataPostMeal(dataPostMeal);
    }, [
        batchesIndex
    ]);
    return {
        chartData,
        chartDataPreMeal,
        chartDataPostMeal
    };
};
